import { render, staticRenderFns } from "./TaskText.vue?vue&type=template&id=973a085e&scoped=true&"
import script from "./TaskText.vue?vue&type=script&lang=js&"
export * from "./TaskText.vue?vue&type=script&lang=js&"
import style0 from "./TaskText.vue?vue&type=style&index=0&id=973a085e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973a085e",
  null
  
)

export default component.exports